// extracted by mini-css-extract-plugin
export default {"CurPage":"CurPage_CurPage__F8hO5","currentPage":"CurPage_currentPage__3rTw3"};